import React from 'react';
import { ToastContainer } from 'react-toastify';
import { Route, Routes, Navigate } from 'react-router-dom';
import Login from '../../views/pages/user/Login.jsx';
import Lock from '../../views/pages/user/Lock.jsx';
import ChangePassword from '../../views/pages/user/ChangePassword.jsx';
import AuthNavbar from '../../components/Navbars/AuthNavbar.jsx';
import Footer from '../../components/Footer/AuthFooter.jsx';
import routes from '../../routes.js';

class Auth extends React.Component {
  filterAuthRoutes = (routeProp) => {
    return routeProp.layout === "/auth";
  }

  getRoutes = routes => {
    let authRoutesFilter = routes.filter(this.filterAuthRoutes)
    console.log(authRoutesFilter)
    let authRoutes = []
    for (var i = 0; i < authRoutesFilter.length; i++) {
      let prop = authRoutesFilter[i]
      if (prop.collapse) {
        authRoutes.push(this.getRoutes(prop.views))
      }
      if (prop.layout === "/auth") {
        authRoutes.push(
          <Route
            path={prop.layout + prop.path}
            element={prop.element}
            key={i}
          />
        )
      }
      console.log(authRoutes, i, authRoutesFilter.length)
      if (i == authRoutesFilter.length - 1) {
        return authRoutes
      }

    };
  };
  getActiveRoute = routes => {
    let authRoutesFilter = routes.filter(this.filterAuthRoutes)
    let activeRoute = "";
    for (let i = 0; i < authRoutesFilter.length; i++) {
      if (authRoutesFilter[i].collapse) {
        let collapseActiveRoute = this.getActiveRoute(authRoutesFilter[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (window && typeof window !== 'undefined' && window.location) {
          if (
            window.location.pathname.indexOf(
              authRoutesFilter[i].layout + authRoutesFilter[i].path
            ) !== -1
          ) {
            console.log(authRoutesFilter[i])
            return authRoutesFilter[i].name;
          }
        }
      }
    }
    return activeRoute;
  };
  getFullPageName = routes => {
    let pageName = this.getActiveRoute(routes);
    switch (pageName) {
      case "login":
        return "login-page";
      case "Feedback":
        return "feedback-page";
      case "Lock Screen":
        return "lock-page";
      default:
        return "";
    }
  };
  componentDidMount() {
    console.log("We mounted Auth")
    console.log(window.location.href)
    document.documentElement.classList.remove("nav-open");
  }

  filterAuthRoutes = (routeProp) => {
    return routeProp.layout === "/auth";
  }
  getRoutes = routes => {
    let authRouteList = this.props.userLevel > 10000 ? WellServicesRoutes : routes
    let authRoutesFilter = authRouteList.filter(this.filterAuthRoutes)
    let authRoutes = []
    for (var i = 0; i < authRoutesFilter.length; i++) {
      let prop = authRoutesFilter[i]
      if (prop.collapse) {
        authRoutes.push(this.getRoutes(prop.children))
      }
      else if (prop.layout === "/auth") {
        authRoutes.push(
          <Route
            path={":" + prop.path}
            element={prop.element}
            key={i}
          />
        )

      }
      if (i == authRoutesFilter.length - 1) {
        return authRoutes
      }

    };
  };

  AuthRoutes() {
    let authRouteList = this.props.userLevel > 10000 ? WellServicesRoutes : routes
    let authRoutesFilter = authRouteList.filter(this.filterAuthRoutes)
    if (authRoutesFilter && authRoutesFilter.length > 0)
      return (
        <Routes>
          {authRoutesFilter.map((route) => (
            <Route
              path={"/" + route.path}
              element={route.element}
              key={route.path}
            />
          ))}

          {/* Add additional routes here as needed */}
          {/* <Route index path="/welcome" element={<Welcome />} /> */}
          {/* <Route path="/dailyCall" element={<MorningCall />} /> */}
        </Routes>
      );
  }
  handleLoadEvent = () => {
    if (window && window.zE) {
      window.zE("webWidget", "hide");
    }
  }
  render() {

    return (
      <>

        <AuthNavbar />
        <div className="rna-container">
          <ToastContainer />
        </div>
        <div className="wrapper wrapper-full-page">
          {this.handleLoadEvent()}
          <div className={"full-page " + this.getFullPageName(routes)}>
            {this.AuthRoutes()}
            <Footer fluid />
          </div>
        </div >
      </>
    );
  }

}

export default Auth;
